import React from 'react'
import { Card, Accordion } from 'react-bootstrap';
export default function StepSeven({
 accordionActiveKey,
 ContextAwareToggle ,
 t ,
 stepSelectedLabel ,
 hasZipcode ,
 zipcode ,
 setZipcode ,
 zipcodeChecked ,
 setZipcodeChecked ,
 measureWindowSize ,
 zipcodeButton ,
 hasInstall ,
 installPrice ,
 transportPrice ,
 addingLoading ,
 setCart ,
 inputs ,
 GetPrice ,
 pageLanguage ,
 isTabletOrMobile ,
 modalHandleShow ,
}) {
  return (
   <Card className={accordionActiveKey === "" ? "card_little_margin" : "card_big_margin"}>
   <Card.Header>
     <ContextAwareToggle
       eventKey="8"
       stepNum={t("7")}
       stepTitle={t("zebra_step7")}
       stepTitle2={t("(Optional)")}
       stepRef="8"
       type="2"
       required={false}
       stepSelected={stepSelectedLabel["8"] === undefined ? "" : stepSelectedLabel["8"]}
     />
   </Card.Header>
   <Accordion.Collapse eventKey="8">
     <Card.Body>
       <div className="card_body card_body_zipcode">
         <div className="zipcode_bag_section">
           <div className="zipcode_section_container">
             <div className="zipcode_text zipcode_section_title_container">
               <img
                 src={require("../../Images/public/W_truck.png")}
                 alt=""
                 className="img-fluid"
               />
               <h3>{t("zipcode_text1")}</h3>
             </div>
             {hasZipcode === "" && (
               <h3 className="zipcode_text">{t("zipcode_text1.5")}</h3>
             )}
             {hasZipcode === "" && (
               <div className="zipcode_dropdown_div_container">
                 <div className="zipcode_input_container" style={{gap: "0.5rem"}}>
                   <input
                     className="form-control"
                     type="text"
                     name="zipcode_input"
                     value={zipcode}
                     placeholder={t("Enter Zip Code")}
                     onChange={(e) => {
                       setZipcode(e.target.value.replace(/\D+/g, ""));
                     }}
                     onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        measureWindowSize(zipcode);
                      }
                    }}
                   />
                   <button
                     className="zipcode_input_button white_btn"
                     onClick={() => {
                       measureWindowSize(zipcode);
                     }}
                   >
                     <div>   
                               {t("UPDATE")}
                                </div>
                   </button>
                 </div>
               </div>
             )}
             {zipcodeButton && hasZipcode === "" && (
               <h3 className="zipcode_text2">
                 {zipcodeButton && hasInstall === false && t("zipcode_text2")}
                 {zipcodeButton && hasInstall && hasZipcode === "" && t("zipcode_text3")}
                 {zipcodeButton &&
                   hasInstall &&
                   hasZipcode !== "" &&
                   installPrice === -1 &&
                   t("zipcode_text3")}
               </h3>
             )}
             {zipcodeButton && hasInstall && installPrice === -1 && (
               <h3 className="zipcode_text">{t("zipcode_text8")}</h3>
             )}
             {zipcodeButton &&
               hasInstall &&
               !!installPrice &&
               installPrice !== -1 &&
               hasZipcode === "" && (
                 <div className="zipcode_available_container">
                   <div className="checkbox_style">
                     <input
                       type="checkbox"
                       value="1"
                       name="zipcode"
                       disabled={addingLoading}
                       checked={zipcodeChecked === "true"}
                       onChange={(e) => {
                         if (e.target.checked) {
                           setZipcodeChecked("true");
                           setCart("ZipCode", zipcode);
                         } else {
                           setZipcodeChecked("false");
                           setCart("", "", "ZipCode");
                         }
                       }}
                       id="zipcode"
                       ref={(ref) => (inputs.current["zipcode"] = ref)}
                     />
                     <label htmlFor="zipcode" className="checkbox_label">
                       <img
                         className="checkbox_label_img checkmark1 img-fluid"
                         src={require("../../Images/public/checkmark1_checkbox.png")}
                         alt=""
                       />
                     </label>
                     <span className="checkbox_text">
                       {t("zipcode_text4")}
                       {GetPrice(
                         installPrice,
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )}
                       {t("zipcode_text5")}
                       <br />
                       {t("zipcode_text5.5")}
                       {GetPrice(
                         transportPrice,
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )}
                       {t("zipcode_text6")}
                     </span>
                   </div>
                 </div>
               )}
             { installPrice !== -1 && hasZipcode && hasZipcode !== "" && (
               <div className="checkbox_style checkbox_style_hasZipcode">
                 <input
                   type="checkbox"
                   value="1"
                   name="zipcode"
                   disabled={addingLoading}
                   checked={zipcodeChecked === "true"}
                   onChange={(e) => {
                     if (e.target.checked) {
                       setZipcodeChecked("true");
                       setCart("ZipCode", zipcode);
                     } else {
                       setZipcodeChecked("false");
                       setCart("", "", "ZipCode");
                     }
                   }}
                   id="zipcode"
                   ref={(ref) => (inputs.current["zipcode"] = ref)}
                 />
                 <label htmlFor="zipcode" className="checkbox_label">
                   <img
                     className="checkbox_label_img checkmark1 img-fluid"
                     src={require("../../Images/public/checkmark1_checkbox.png")}
                     alt=""
                   />
                 </label>
                 <span className="checkbox_text">
                   {t("zipcode_text4")}
                   {GetPrice(installPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                   {t("zipcode_text5")}
                 </span>
               </div>
             )}
           </div>
         </div>
       </div>
       <div className=" accordion_help">
         <div className=" help_container">
           <div className=" help_column help_left_column">
             <p className=" help_column_header" />
             <ul className=" help_column_list">
               <li>{t("stepZip_help_1")}</li>
               <li>{t("stepZip_help_2")}</li>
               <li>
                 {t("stepZip_help_3")}
                 <h5
                   className="text_underline pointer"
                   onClick={() => modalHandleShow("Zipcode_how_it_works")}
                 >
                   {t("zipcode_measure_verify")}
                 </h5>
               </li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
